import * as angular from 'angular';

import { ComponentDefinition, IUiSelectItem } from '../../models';

interface IAlarmCategory { name: string; }

class AlarmCategoriesMultiSelectController implements angular.IComponentController {
    alarmCategories: string[];
    selectedCategories: string[];
    alarmId: string;
    formController: angular.IFormController;

    public readonly createNewCategory: (model) => IAlarmCategory;

    static $inject = ['$translate'];
    constructor(private readonly _$translate: angular.translate.ITranslateService) {
        const replace = ` ${this._$translate.instant('(Enter to create)')}`;
        this.createNewCategory = (model) => {
            return { name: `${model}${replace}` } as IAlarmCategory;
        };
    }

    onSelect($item: string | IUiSelectItem) {
        if ($item && ($item as IUiSelectItem).isTag) {
            this.selectedCategories = this.selectedCategories.filter(sc => sc !== ($item as string));
            const replace = ` ${this._$translate.instant('(Enter to create)')}`;
            this.selectedCategories.push(($item as IUiSelectItem).name.replace(replace, ''));
            this.alarmCategories.push(($item as IUiSelectItem).name.replace(replace, ''));
        }
        if (this.formController) {
            this.formController.$setDirty();
        }
        }

    onRemove() {
        if (this.formController) {
            this.formController.$setDirty();
        }
    }
}

export const wtAlarmCategoriesMultiSelect: ComponentDefinition = {
    componentId: 'wtAlarmCategoriesMultiSelect',
    controller: AlarmCategoriesMultiSelectController,
    template: require('./alarmCategoriesMultiSelect.component.html'),
    controllerAs: 'vm',
    bindings: {
        alarmCategories: '<',
        selectedCategories: '=',
        alarmId: '<',
        formController: '<?'
    }
};
